import { schoolTokenAxios } from "../axios";

const SCHOOL_REPORTING_BASE = process.env.REACT_APP_SCHOOL_REPORTING_BASE;

let BulkUpload = `${SCHOOL_REPORTING_BASE}/bulkUpload`;

export const uploadHouseData = (payload) => {
    return schoolTokenAxios.post(`${BulkUpload}/uploadHouseData`, payload);
}